<div class="dashboard" style="height: 600px;" [hidden]="myHidden" [class.embedded]="comesFromOneShipment">
  <div class="chat-sidebar j-chat-sidebar active" [class.d-none]="comesFromOneShipment">
    <div class="chat-sidebar__inner">
      <div class="chat-sidebar__header border-bottom text-center">
        <a class="dashboard__logo" [routerLink]="this.globals.isForwarder() ? '/my-transport-company' : '/my-company'">
          <img alt="Company Image"
               *ngIf="this.globals !== undefined && this.globals !== null && this.globals.enterpriseLogo !== undefined
                      && this.globals.enterpriseLogo !== null && this.globals.enterpriseLogo !== ''"
               src="{{this.globals.getEnvironment().baseApiUrl}}files/{{this.globals.enterpriseLogo}}">
        </a>
        <div class="dashboard__status_wrap">
          <p class="dashboard__status j-dashboard_status font-weight-bold" style="top: 14px; position: relative;" *ngIf="loggedinUser !== undefined">
            {{loggedinUser.full_name}}
          </p>
        </div>
        <!--<a (click)="logout(loggedinUser.id)" class="logout j-logout">logout</a>-->
      </div>
      <div class="chat-sidebar__content">
        <ul class="chat-sidebar__tabs">
          <li class="chat-sidebar__tab" style="width: 100%">
            <a [class.active]="chatsClicked" class="chat-sidebar__tab_link" target="_blank">{{'MY_SHIPMENTS.CHAT_DASHBOARD.YOUR_CHATS' | translate}}</a>
          </li>
          <!--<li class="chat-sidebar__tab">
            <a (click)="getChatList('publicChats')" [class.active]="publicChatClicked"
               class="chat-sidebar__tab_link j-chat-sidebar__tab_link" target="_blank">public chats</a>
          </li>
          <li class="chat-sidebar__tab m-chat-sidebar__tab_new">
            <a (click)="createNewGroup()" [class.active]="createGroupClicked"
               class="chat-sidebar__tab_link j-chat-sidebar__create_dialog m-chat-sidebar__tab_link_new"
               target="_blank">
              <i class="material-icons notranslate">add_circle_outline</i>
            </a>
          </li>-->
        </ul>
        <ul class="chat-sidebar__dilog_list j-chat-sidebar__dilog_list px-2 pb-1">
          <li (click)="openChat(chat)"
              *ngFor="let chat of chats" [ngClass]="{'selected': selectedChat === chat._id}"
              class="dialog__item rounded border j-dialog__item">
            <a class="dialog__item_link">
                            <span class="dialog__avatar">
                                <i class="material-icons notranslate">account_circle</i>
                            </span>
              <span class="dialog__info">
                                <span class="dialog__name">{{chat.name}}</span>
                                <span class="dialog__last_message j-dialog__last_message">{{chat.last_message}}</span>
                            </span>
              <span class="dialog_additional_info">
                                <span class="dialog__last_message_date j-dialog__last_message_date">
                                    {{chat.last_message_date_sent | date:'hh:mm'}}
                                </span>
                                <span *ngIf="chat.unread_messages_count > 0"
                                      class="dialog_unread_counter j-dialog_unread_counter">
                                    {{chat.unread_messages_count}}
                                </span>
                            </span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div>

  </div>
  <app-create-chat-dialog [hidden]="!createGroupClicked" [dialog]="dialog"></app-create-chat-dialog>
  <app-edit-chat-dialog *ngIf="updateDialog" [dialog]="dialog"></app-edit-chat-dialog>
  <div *ngIf="welcomeChat" class="content j-content">
    <div class="content__title j-content__title j-welcome text-center">
      {{'MY_SHIPMENTS.CHAT_DASHBOARD.INNPORTING_CHAT_SYSTEM' | translate}}
    </div>
    <div class="notifications j-notifications hidden"></div>
    <div class="content__inner j-content__inner">
      <div class="welcome__message">
        <p>{{'MY_SHIPMENTS.CHAT_DASHBOARD.SELECT_CONVERSATION' | translate}}</p>
      </div>
    </div>
  </div>
  <app-chat-dialogs *ngIf="onChatClick && dialog" [dialog]="dialog"></app-chat-dialogs>

</div>
